var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSleepDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06498 2.18681C8.19439 2.40981 8.1836 2.68745 8.03728 2.89974C7.59335 3.54383 7.3335 4.32385 7.3335 5.16656C7.3335 7.37569 9.12436 9.16655 11.3335 9.16655C12.1762 9.16655 12.9562 8.9067 13.6003 8.46277C13.8126 8.31645 14.0902 8.30566 14.3132 8.43507C14.5363 8.56448 14.6646 8.81088 14.6429 9.0678C14.3543 12.4842 11.4909 15.1666 8.00016 15.1666C4.31826 15.1666 1.3335 12.1818 1.3335 8.49989C1.3335 5.0092 4.01583 2.1457 7.43225 1.85711C7.68917 1.83541 7.93557 1.9638 8.06498 2.18681ZM6.28299 3.44889C4.18012 4.16357 2.66683 6.15525 2.66683 8.49989C2.66683 11.4454 5.05464 13.8332 8.00016 13.8332C10.3448 13.8332 12.3365 12.3199 13.0512 10.2171C12.5119 10.4004 11.934 10.4999 11.3335 10.4999C8.38798 10.4999 6.00016 8.11207 6.00016 5.16656C6.00016 4.56602 6.09963 3.98815 6.28299 3.44889Z",
    fill: "#03071275"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepDefault);
export default __webpack_public_path__ + "static/media/sleep-default.13554a16449f5c5894142cd8a0f48c97.svg";
export { ForwardRef as ReactComponent };